import React from 'react'
import { SeverityLevel } from '@microsoft/applicationinsights-common'

import { logTrace } from '../../Global/App/ApplicationInsights'
import List from '../../Components/List/List'
import NextUp from '../../Components/NextUp/NextUp'
import ShiftDay from '../../Components/ShiftDay/ShiftDay'
import FailureState from '../Failure/FailureState'

const SuccessState: React.FC<{
    data: any[]
    destination: string
}> = ({ data, destination }) => {
    if (!data || !(data instanceof Array)) {
        logTrace(`API said OK but data is incorrect, expected an array but got ${typeof data}`, SeverityLevel.Warning)

        return <FailureState />
    }

    if (!data.length) {
        // Prio 9 error - stop in traffic (or maybe something strange?)
        return <FailureState />
    }

    const timeBetweenDepartures = []
    const nextUp = data[0].timeLeft

    const nextHour = data.filter((d: any) => d.timeLeft < 60)
    const futureHours = data.filter((d: any) => d.timeLeft >= 60)

    for (let i = 1; i < data.length; i++) {
        timeBetweenDepartures.push(data[i].timeLeft - data[i - 1].timeLeft)
    }

    if (nextUp >= 60) {
        // Show departure time when next train departs in over 60 minutes
        return <NextUp departure={data[0]} />
    } else if (nextHour.length === 1 && timeBetweenDepartures[0] > 60) {
        // Show half/half when next train is the last one before morning
        return <ShiftDay nowDeparture={nextHour[0]} nextDeparture={futureHours[0]} />
    } else {
        // Show list of comming departures
        return <List data={data} destination={destination} />
    }
}

export default SuccessState
